import c from "@emotion/styled/base";
import { Text as d } from "../../../Text/index.js";
const i = /* @__PURE__ */ c(d, process.env.NODE_ENV === "production" ? {
  target: "etdjedi0"
} : {
  target: "etdjedi0",
  label: "StyledNotice"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvTnVtYmVySW5wdXQvc3ViQ29tcG9uZW50cy9Ob3RpY2UvTm90aWNlLnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJd0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9OdW1iZXJJbnB1dC9zdWJDb21wb25lbnRzL05vdGljZS9Ob3RpY2Uuc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vLi4vVGV4dCc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWROb3RpY2UgPSBzdHlsZWQoVGV4dClgYDtcbiJdfQ== */");
export {
  i as StyledNotice
};
